// this is utlity function to get current date string
const getCurrentDateString = () => new Date(Date.now()).toISOString();

export default getCurrentDateString;
